import React, { useState } from "react";
import styles from "./Header.module.scss";
import "./Header.scss";
import Header from "../../assets/images/WandaLogoFull.svg";
import accountMenuIcon from "../../assets/images/accountMenuIcon.svg";
import logoutIcon from "../../assets/images/logoutIcon.svg";
import { useHistory } from "react-router-dom";
import { Button, Drawer } from "antd";
import AccountMenu from "../AccountMenu/AccountMenu";
import * as OauthCodeFlowService from "../../services/AuthService/OauthCodeFlowService";

export default function ProfileHeader() {
  const [showDrawer, setShowDrawer] = useState<boolean>(false);
  const [panelActiveKey, setPanelActiveKey] = useState<string[]>([]);
  const oauthCodeFlow = OauthCodeFlowService;

  const history = useHistory();
  const handleWandaLogoClick = () => history.push("/DashBoard");

  const handleOpenAccountMenu = () => {
    setShowDrawer(true);
  };
  const handleDrawerClose = () => {
    setPanelActiveKey([]);
    setShowDrawer(false);
  };

  function logout() {
    handleDrawerClose();
    sessionStorage.clear();
    oauthCodeFlow.logout();
  }

  return (
    <>
      <div className={styles.headerSetup}>
        <div className={styles.accountInfo}>
          <img
            src={accountMenuIcon}
            alt="accountMenuIcon"
            onClick={handleOpenAccountMenu}
          />
          <div>Dashboard</div>
        </div>
        <div>
          <img
            src={Header}
            alt="HeaderLogo"
            className={styles.headerLogo_Desktop}
            onClick={handleWandaLogoClick}
          />
        </div>
        <div className={styles.headerSpace} />
      </div>
      <div className={styles.gradientBorder} />
      <div>
        <Drawer
          visible={showDrawer}
          closable={false}
          onClose={handleDrawerClose}
          placement="left"
          height={"auto"}
          className={styles.accountMenuDrawer}
          footer={
            <>
              <div className={styles.gradientBorder} />
              <Button id={styles.accountItems} onClick={logout}>
                <img src={logoutIcon} alt="logoutIcon" />
                <span>Logout</span>
              </Button>
            </>
          }
        >
          <AccountMenu
            panelActiveKey={panelActiveKey}
            setPanelActiveKey={setPanelActiveKey}
            handleDrawerClose={handleDrawerClose}
          />
        </Drawer>
      </div>
    </>
  );
}
